export default __webpack_public_path__ + "static/media/portal-logo.5fd45e0b.svg";